import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import { Card, CardContent, Grid, Button } from "@material-ui/core/";
import { withStyles } from "@material-ui/core/styles";

import { Stepper, Snackbar } from "../../../components";
import { Identification, Owner, CrecheInfo } from "./forms";
import SignupInitialValue from "./SignupInitialValues";
import { createCrecheSchema } from "./Signup-schema";
import SignupStyles from "./SignupStyles";

import { createCreche } from "../Auth.ducks";

import { CardHeader, CardActions } from "../../../components";

class Signup extends Component {
  static propTypes = {
    createCreche: PropTypes.func,
    auth: PropTypes.object,
    classes: PropTypes.object,
    t: PropTypes.func
  };

  state = {
    wizzard: 0,
    steps: [],
    activeStep: 0,
    snackBarStatus: false
  };

  static getDerivedStateFromProps(props, state) {
    if (state.steps.length === 0) {
      const { t } = props;
      return {
        steps: [
          { status: false, text: t("signup.step_identification") },
          { status: false, text: t("signup.step_owner") },
          { status: false, text: t("signup.step_creche_info") }
        ]
      };
    }
    return null;
  }

  handleRightButtonClick = values => {
    if (this.state.wizzard < 2) {
      this.handleNextClick();
    } else {
      this.handleSubmit(values);
    }
  };

  handleSubmit = async values => {
    await this.props.createCreche(values);
    if (this.props.auth.creche.id) {
      this.setState({ snackBarStatus: true });
      setTimeout(() => {
        this.setState({ snackBarStatus: false });
      }, 6000);
    }
  };

  handleNextClick = () => {
    let { steps, wizzard, activeStep } = this.state;
    steps[wizzard].status = true;
    activeStep = wizzard + 1;
    this.setState({ wizzard: wizzard + 1, steps, activeStep });
  };

  handleBackClick = () => {
    let { steps, wizzard, activeStep } = this.state;
    steps[wizzard].status = false;
    steps[wizzard - 1].status = false;
    activeStep = wizzard - 1;
    this.setState({ wizzard: wizzard - 1, steps, activeStep });
  };

  render() {
    const { root, formBtnHidden } = this.props.classes;
    const { t } = this.props;

    return (
      <div className={root}>
        <Card>
          <Formik
            initialValues={SignupInitialValue}
            validationSchema={createCrecheSchema(t)}
            onSubmit={(values, actions) => console.log(values)}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              initialValues,
              errors,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <CardHeader title={t("signup.step_identification")} />
                <CardContent>
                  <Stepper
                    steps={this.state.steps}
                    activeStep={this.state.activeStep}
                  />

                  {(() => {
                    switch (this.state.wizzard) {
                      case 0:
                        return (
                          <Identification
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            values={values}
                            touched={touched}
                            errors={errors}
                          />
                        );
                      case 1:
                        return (
                          <Owner
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            values={values}
                            touched={touched}
                            errors={errors}
                          />
                        );
                      case 2:
                        return (
                          <CrecheInfo
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            values={values}
                            touched={touched}
                            errors={errors}
                          />
                        );
                      default:
                        return 0;
                    }
                  })()}
                </CardContent>
                <CardActions>
                  <Grid justify="space-between" container spacing={24}>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        className={
                          this.state.wizzard === 0 ? formBtnHidden : null
                        }
                        onClick={this.handleBackClick}
                      >
                        {t("signup.previous")}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={
                          this.state.wizzard === 2 &&
                          (Object.keys(errors).length > 0 ||
                            Object.keys(touched).length === 0)
                        }
                        type={this.state.wizzard === 2 ? "submit" : ""}
                        onClick={() =>
                          this.handleRightButtonClick(
                            this.state.wizzard === 2 ? values : null
                          )
                        }
                      >
                        {this.state.wizzard === 2 ? t("signup.create") : t("signup.next")}
                      </Button>
                    </Grid>
                  </Grid>
                </CardActions>
              </form>
            )}
          </Formik>
          <Snackbar
            snackBarStatus={this.state.snackBarStatus}
            snackBarMessage={t("signup.success")}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = { createCreche };

const withStore = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withStyles(SignupStyles)(withTranslation()(withStore(Signup)));
